'use client';

import { MobileFooterProps } from '@/types/dataTypes';
import Image from 'next/image';
import Link from 'next/link';
import copy from 'copy-to-clipboard';
import { useState } from 'react';

const Footer = ({ wechatNum, phoneNumber }: MobileFooterProps) => {
	const [showCopyMessage, setShowCopyMessage] = useState(false);

	const handleCopy = () => {
		copy(wechatNum);
		setShowCopyMessage(true);
		setTimeout(() => setShowCopyMessage(false), 2000);
	};

	return (
		<div className="">
			<div
				id="hs-basic-modal"
				className="hs-overlay hidden w-[70%] h-[50rem] fixed top-[40%] left-[15%] z-[60] overflow-x-hidden overflow-y-auto"
			>
				<div className="hs-overlay-open:opacity-100 hs-overlay-open:duration-500 opacity-0 transition-all m-3">
					<div className="flex flex-col bg-[#eeeeee] text-[#333333] border shadow-sm rounded-xl dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
						<div className="flex justify-end items-center px-4 dark:border-gray-700">
							<button
								type="button"
								className="inline-flex flex-shrink-0 justify-center items-center pt-3 h-8 w-8 rounded-md text-gray-500 hover:text-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 focus:ring-offset-white transition-all text-sm dark:focus:ring-gray-700 dark:focus:ring-offset-gray-800"
								data-hs-overlay="#hs-basic-modal"
							>
								<svg
									className="w-3.5 h-3.5"
									width="8"
									height="8"
									viewBox="0 0 8 8"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M0.258206 1.00652C0.351976 0.912791 0.479126 0.860131 0.611706 0.860131C0.744296 0.860131 0.871447 0.912791 0.965207 1.00652L3.61171 3.65302L6.25822 1.00652C6.30432 0.958771 6.35952 0.920671 6.42052 0.894471C6.48152 0.868271 6.54712 0.854471 6.61352 0.853901C6.67992 0.853321 6.74572 0.865971 6.80722 0.891111C6.86862 0.916251 6.92442 0.953381 6.97142 1.00032C7.01832 1.04727 7.05552 1.1031 7.08062 1.16454C7.10572 1.22599 7.11842 1.29183 7.11782 1.35822C7.11722 1.42461 7.10342 1.49022 7.07722 1.55122C7.05102 1.61222 7.01292 1.6674 6.96522 1.71352L4.31871 4.36002L6.96522 7.00648C7.05632 7.10078 7.10672 7.22708 7.10552 7.35818C7.10442 7.48928 7.05182 7.61468 6.95912 7.70738C6.86642 7.80018 6.74102 7.85268 6.60992 7.85388C6.47882 7.85498 6.35252 7.80458 6.25822 7.71348L3.61171 5.06702L0.965207 7.71348C0.870907 7.80458 0.744606 7.85498 0.613506 7.85388C0.482406 7.85268 0.357007 7.80018 0.264297 7.70738C0.171597 7.61468 0.119017 7.48928 0.117877 7.35818C0.116737 7.22708 0.167126 7.10078 0.258206 7.00648L2.90471 4.36002L0.258206 1.71352C0.164476 1.61976 0.111816 1.4926 0.111816 1.36002C0.111816 1.22744 0.164476 1.10028 0.258206 1.00652Z"
										fill="currentColor"
									/>
								</svg>
							</button>
						</div>
						<div className="pt-[0.5rem] overflow-y-auto mx-auto">
							<Image
								className=""
								alt="home_bottom_tel"
								width={140}
								height={140}
								src={'/erweima1.jpg'}
							></Image>
						</div>
						<div className="mx-auto text-[1.46rem] leading-[2.75rem]">
							截屏，微信识别二维码
						</div>
						<div className="mx-auto text-[1.46rem] leading-[2.75rem]">
							微信号：
							<button
								className="text-white bg-[#1a466d] px-[0.5rem] h-[2.5rem] rounded-md"
								onClick={handleCopy}
							>
								{wechatNum}
							</button>
						</div>
						<div className="mx-auto text-[1.46rem] leading-[2.75rem]">
							（点击微信号复制，添加好友）
						</div>
						<button
							className="flex flex-row justify-center items-center text-white bg-[#1a466d] p-[1rem] my-[1rem] h-[2.5rem] rounded-md mx-auto"
							onClick={() => {
								window.location.href = 'weixin://';
							}}
						>
							<div className="w-[2rem] h-[2rem] relative">
								<Image
									className="object-contain"
									alt="home_bottom_tel"
									fill
									sizes="10vw"
									src={'/m_img/mobile_wechat.png'}
								></Image>
							</div>
							&nbsp;&nbsp;打开微信
						</button>
					</div>
				</div>
			</div>
			<div className="w-full fixed bottom-0 left-0 h-[7.5rem] bg-[#3c3c3c] flex flex-row">
				<Link
					className="flex flex-1 flex-col items-center justify-around py-4"
					href="/m"
				>
					<Image
						className="mx-auto"
						alt=""
						src="/m_img/mobile_home.png"
						width={27}
						height={27}
					></Image>
					<span className="inline-block w-full text-center text-[1.3rem] text-white">
						首页
					</span>
				</Link>
				<a
					className="flex flex-1 flex-col items-center justify-around py-4"
					href={'tel:' + phoneNumber}
				>
					<Image
						className=""
						alt=""
						src="/m_img/mobile_phone.png"
						width={27}
						height={27}
					></Image>
					<span className="inline-block w-full text-center text-[1.3rem] text-white">
						电话咨询
					</span>
				</a>
				<button
					className="flex flex-1 flex-col items-center justify-around py-4"
					data-hs-overlay="#hs-basic-modal"
				>
					<Image
						className=""
						alt=""
						src="/m_img/mobile_wechat.png"
						width={27}
						height={27}
					></Image>
					<span className="inline-block w-full text-center text-[1.3rem] text-white">
						微信咨询
					</span>
				</button>
				<Link
					className="flex flex-1 flex-col items-center justify-around py-4"
					href="/m/contact"
				>
					<Image
						className=""
						alt=""
						src="/m_img/mobile_location.png"
						width={27}
						height={27}
					></Image>
					<span className="inline-block w-full text-center text-[1.3rem] text-white">
						联系我们
					</span>
				</Link>
			</div>
			{showCopyMessage && (
				<div className="text-[1.58rem] text-center fixed bottom-[20%] left-1/2 transform -translate-x-1/2 bg-black bg-opacity-80 z-[70] text-white px-4 py-2 rounded-md">
					微信号已复制，请打开微信添加咨询详情！
				</div>
			)}
		</div>
	);
};

export default Footer;
